/**
 * #961 (owner, 12 Oct): a share-view "Log out" in another tab of this browser ends EVERY
 * share visit the browser has open, this one included (the server ends each visit bound to
 * this browser). Ask the server whether THIS session is gone; if so, go to the link's front
 * door at once instead of showing the folder until the next request fails.
 */
import { useEffect } from 'react'
import { getApiBase } from '@papan/api-client'
import { onSignedOutElsewhere } from '../../lib/sign-out-broadcast'
import { endShareVisit, leaveShareView } from './shareLeave'

export function useLeaveOnSignOutElsewhere(sessionId: string | null | undefined, shareToken: string | null | undefined): void {
  useEffect(() => {
    if (!sessionId || !shareToken) return
    return onSignedOutElsewhere(() => {
      // E7 PR 0b: the session-ended helper FIRST — signed out in another tab; in-flight work is dropped before the check
      endShareVisit('signed-out-elsewhere')
      void fetch(`${getApiBase()}/api/share-links/session/${encodeURIComponent(sessionId)}/info`, { credentials: 'include' })
        .then((res) => {
          if (res.status === 404) leaveShareView(`/share/${encodeURIComponent(shareToken)}`, 'signed-out-elsewhere')
        })
        .catch(() => { /* unanswerable: stay; the view's next request says what happened */ })
    })
  }, [sessionId, shareToken])
}
